import gql from 'graphql-tag';

export const QUERY_BONO_APLICABLE = gql(`
  query bonoAplicable($idBorrador: Long){
   bonoAplicable (idBorrador: $idBorrador) {
      aplicado
      contadorUsos
      idPromocion
      numeroDeUsos
      encontrado
    }
  }
`)

export const QUERY_BONOS_APLICABLES = gql(`
  query bonosAplicables($uuid: UUID, $codigoProducto: String){
    bonosAplicables (uuid: $uuid, codigoProducto: $codigoProducto) {
      aplicado
      contadorUsos
      idPromocion
      numeroDeUsos
      encontrado
    }
  }
`)
